import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';
import { NavLink } from 'react-router-dom';
import atoms from 'ctsutheme/components/atoms';
import { FasBars } from 'assets/icons';

const { Icon, Tooltip } = atoms;

export default function BurgerMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  const { routes } = props;

  return (
    <>
      <Tooltip
        tooltipplacementbottom="true"
        title="Menu"
        component="div"
      >
        <Icon
          aria-label="More"
          aria-controls="sticky-header-burger-menu"
          aria-haspopup="true"
          onClick={handleClick}
          color="primary"
        >
          <FasBars />
        </Icon>
      </Tooltip>
      <Menu
        id="sticky-header-burger-menu"
        className="sticky-header-burger-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        <MenuItem className="nav-link sticky-header-burger-menu-title">
          Menu
          <Icon
            aria-label="Menu"
            color="primary"
          >
            <FasBars />
          </Icon>
        </MenuItem>
        {routes.map(({
          name, shortName, path, isExact, showInMenu
        }) => (showInMenu && (
          <NavLink
            key={_.uniqueId('nav-link-route-sticky')}
            exact={isExact}
            activeClassName="active"
            className="nav-link"
            to={path}
          >
            <MenuItem
              onClick={handleClose}
            >
              {shortName}
            </MenuItem>
          </NavLink>
        )))}
      </Menu>
    </>
  );
}
